import { postCancelBroadband } from "@modules/eirCustomersFacade/api";
import { useState } from "react";
import { subMonths } from "date-fns";
import { useOrderList } from "@features/Order/hook/useOrderList";
import { MONTH_INTERVAL_LIST } from "@features/Order/utils";

interface IParams {
    isHomePage: boolean;
}

export const useOrderHandler = (props: IParams) => {
    const { isHomePage } = props;
    const { orderList: historyOrderList, getOrdersState: historyOrderListState, getOrders } = useOrderList();
    const [selectedMonth, setSelectedMonth] = useState(MONTH_INTERVAL_LIST[0]);

    const getHistoryOrderList = () => getOrders(subMonths(new Date(), selectedMonth).toISOString());

    const cancelOrder = async (orderReference: string) => {
        try {
            await postCancelBroadband(orderReference);
            if (!isHomePage) {
                getHistoryOrderList();
            }
        } catch (error) {
            // TODO GAW-304
        }
    };

    return {
        cancelOrder,
        getHistoryOrderList,
        historyOrderList,
        historyOrderListState,
        selectedMonth,
        setSelectedMonth,
    };
};
